export const SHIPPING_FEE_RSD = 600;

export const DELIVERY_NOTICE_TITLE = "Uslovi dostave";

export const DELIVERY_NOTICE_PARAGRAPHS = [
  "U Beogradu dostavljamo na vašu adresu već 7 godina. Pouzdana isporuka domaćih proizvoda direktno do vaših vrata.",
  "Besplatna dostava u Beogradu važi za porudžbine preko 6.500 RSD.",
  "Za Niš i Novi Sad dostupno je slanje prevozom. Uplatu možete izvršiti naknadno na tekući račun.",
  "Sve ostale pošiljke šaljemo poštom širom Srbije.",
  "Vaše je da poručite. Ako ispunjavate ove uslove, dostava će se obračunati ali neće naplatiti. Naš tim će vas kontaktirati radi dogovora oko isporuke i plaćanja.",
];

export const DELIVERY_NOTICE_FULL = DELIVERY_NOTICE_PARAGRAPHS.join(" ");

export const DELIVERY_NOTICE_SHORT =
  "Beograd: dostava na adresu već 7 godina, besplatno preko 6.500 RSD. Niš i Novi Sad: prevoz, uplata naknadno na tekući račun. Ostale lokacije: slanje poštom. Poručite online. Ako ispunjavate uslove, dostava se obračunava ali neće biti naplaćena pri dogovoru. Naš tim vas kontaktirati.";

export const VIBER_CHAT_URL = "viber://chat?number=%2B381601140402";
export const WHATSAPP_CHAT_URL = "https://wa.me/381601140402";
export const CONTACT_PHONE_DISPLAY = "+381601140402";
export const CONTACT_PHONE_TEL = "tel:+381601140402";
